import { ArrowRight, User, LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';
import './Navbar.css';

export default function Navbar() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = async () => {
    await signOut();
    navigate('/');
  };

  const handleScrollTo = (e, targetId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/#' + targetId);
      // Smooth scroll will be handled by the Landing page or browser default
      return;
    }
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      return;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="navbar" aria-label="Primary">
      <div className="navbar__container">
        <a href="#top" className="navbar__brand" onClick={scrollToTop}>
          <img src={logo} alt="Revitrone Logo" className="navbar__logo" />
          REVTRONE
          <span className="navbar__brandUnderline" />
        </a>

        <div className="navbar__links" role="navigation" aria-label="Sections">
          <a className="navbar__link" href="#features" onClick={(e) => handleScrollTo(e, 'features')}>
            Features
          </a>
          <a className="navbar__link" href="#video-section" onClick={(e) => handleScrollTo(e, 'video-section')}>
            Showcase
          </a>
          <a className="navbar__link" href="#pricing" onClick={(e) => handleScrollTo(e, 'pricing')}>
            Pricing
          </a>
          <a className="navbar__link" href="/community">
            Community
          </a>
        </div>

        <div className="navbar__actions">
          {user ? (
            <>
              <a className="navbar__dashboard" href="/dashboard">
                <User size={16} />
                Dashboard
              </a>
              <button className="navbar__logout" onClick={handleSignOut} title="Sign out">
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <>
              <a className="navbar__login" href="/login">
                Log in
              </a>
              <a className="navbar__cta" href="/signup">
                <span>Get Started</span>
                <ArrowRight className="navbar__ctaIcon" aria-hidden="true" />
              </a>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

